/* Reuse the theme's native product form and variant state; never create a second cart request. */
if (!customElements.get('wombat-sticky-buy')) {
  customElements.define('wombat-sticky-buy', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      if (!this.root) return;
      this.button = this.querySelector('[data-sticky-submit]');
      this.sync = this.sync.bind(this);
      this.onClick = () => {
        const source = this.root.querySelector('.product-form__submit');
        if (!source || source.disabled || source.getAttribute('aria-disabled') === 'true') return;
        const recipient = this.root.querySelector('recipient-form');
        if (recipient) {
          recipient.scrollIntoView({ behavior: 'smooth', block: 'center' });
          recipient.querySelector('input')?.focus({ preventScroll: true });
          return;
        }
        source.click();
      };
      this.button.addEventListener('click', this.onClick);
      this.onInput = () => requestAnimationFrame(this.sync);
      this.root.addEventListener('change', this.onInput);
      this.observer = new MutationObserver(mutations => {
        if (mutations.some(m => !this.contains(m.target))) this.sync();
      });
      this.observer.observe(this.root, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'], characterData: true });
      this.sync();
      this.hidden = false;
    }
    sync() {
      const source = this.root.querySelector('.product-form__submit');
      if (!source) { this.hidden = true; return; }
      const busy = source.disabled || source.getAttribute('aria-disabled') === 'true';
      this.button.disabled = busy;
      this.button.textContent = source.querySelector('span')?.textContent.trim() || '加入購物車';
      const price = this.root.querySelector('[id^="price-"] .price');
      const currentPrice = price?.querySelector(price.classList.contains('price--on-sale') ? '.price-item--sale' : '.price__regular .price-item--regular');
      if (currentPrice) this.querySelector('[data-sticky-price]').textContent = currentPrice.textContent.trim();
      const picker = this.root.querySelector('variant-selects');
      if (picker) {
        const selected = [...picker.querySelectorAll('select')].map(s => s.selectedOptions[0]?.textContent.trim()).concat([...picker.querySelectorAll('input:checked')].map(i => i.value)).filter(Boolean);
        this.querySelector('[data-sticky-variant]').textContent = selected.join(' ／ ');
      }
      const error = this.root.querySelector('.product-form__error-message-wrapper');
      if (error && !error.hidden && error.textContent.trim()) error.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.onClick);
      this.root?.removeEventListener('change', this.onInput);
    }
  });
}
